
<template>
    <div>
        <template v-for="(scope, key) in scopes"> 
            <template v-if="(typeof scope === 'object' || Array.isArray(scope))">
                <div class='form-group' :id="'id-form-opt-'+key " :class="{'wp-5' : parent ==='all' , 'pl-4' : key !== 'all'}" :key="key">
                    <label  class="form-label label-auto bold" >
                        <input type="checkbox" name="options[]" :id="'opt-'+key" :value="`${key}`" @change="handleChecked(key, scope, $event.target.checked, true)" :checked="isChecked(key)"/>
                        {{ key === "all" ? $l10n.__('Tous') : key }}
                    </label>
                    <scopes-input 
                        :class="{'scope-group' : !parent }"
                        :scopes="scope ? scope : []"
                        :value="value"
                        :parent="key" 
                        :handleChecked="handleChecked" 
                    />
                </div>  
            </template>
            <template v-else> 
                <div class="form-group ml-4" :key="key">
                <label class="form-label label-auto">
                    <input type="checkbox" name="options[]" :id="'opt-'+scope" :value="`${scope}`" @change="handleChecked(key, scope, $event.target.checked, true)" :checked="isChecked(scope)"/>
                    {{scope}}
                </label>
                </div>
            </template>
        </template>
    </div>
</template>
<script>

export default {
    name: "scopes-input",
    props : {
        scopes : {
            type: [Object, Array],
            default: [],
            required: true
        },
        value: {
            type: [Array],
            required: false
        },
        parent: {
            type : String,
            required: false
        },
        handleChecked:
        {
            type : Function,
            required : true,
        },
    },
    data() {
        return {
            options: [],
        };
    },
    created() {
        let options =  this.scopes.all;
    },
    methods: {
        isChecked(value) {
            return this.value.includes(value);
        },
    },
}
</script>
<style lang="sass" scoped>
    .scope-group {
        display: block;
        flex-wrap: wrap;
        overflow: auto;
        max-height: 400px;
    }

    #id-form-opt-private{
        padding-left:0px!important;
    }

</style>